{
    "header" : "כל הפעולות בית הכנסת",
    "balance" : "מאזן",
    "transaction" : "בצע פעולה"
}